/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
.li {
  list-style-type: none;
  cursor: pointer;
  white-space: nowrap;
  margin-inline: calc(var(--spacing, 0.25rem) * 2);
}
